{
  "login": {
    "subtitle": "Espace Administration",
    "email_label": "Adresse email",
    "email_placeholder": "votre.email@djayma.com",
    "password_label": "Mot de passe",
    "password_placeholder": "Votre mot de passe",
    "submit": "Se connecter",
    "submitting": "Connexion en cours...",
    "footer": "Accès réservé aux gérants Djayma",
    "error_invalid": "Email ou mot de passe incorrect.",
    "error_network": "Erreur de connexion. Veuillez réessayer.",
    "error_rate_limit": "Trop de tentatives. Veuillez patienter.",
    "error_unauthorized": "Ce compte n'a pas accès à l'administration Djayma."
  },
  "nav": {
    "sections": {
      "principal": "Principal",
      "commerce": "Commerce",
      "payments": "Paiements",
      "delivery": "Livraison",
      "b2b": "B2B",
      "crm": "CRM",
      "marketing": "Marketing",
      "finance": "Finance",
      "operations": "Opérations",
      "croissance": "Croissance",
      "gestion": "Gestion",
      "analytique": "Analytique",
      "administration": "Administration",
      "settings": "Paramètres",
      "yoboulmako": "Yoboulmako",
      "djayma": "DJAYMA"
    },
    "dashboard": "Tableau de bord",
    "orders": "Commandes",
    "products": "Produits",
    "categories": "Catégories",
    "inventory": "Inventaire",
    "stock_alerts": "Alertes stock",
    "notifications": "Notifications",
    "payment_manager": "Gestionnaire paiements",
    "reconciliation": "Réconciliation",
    "refunds": "Remboursements",
    "disputes": "Litiges",
    "daily_cash": "Rapport caisse",
    "delivery_board": "Tableau d'affectation",
    "drivers": "Chauffeurs",
    "route_optimization": "Optimisation routes",
    "live_tracking": "Suivi en direct",
    "yango": "Yango",
    "delivery_zones": "Zones",
    "delivery_slots": "Créneaux",
    "depots": "Dépôts",
    "delivery_performance": "Performance",
    "b2b_customers": "Comptes B2B",
    "b2b_price_lists": "Grilles tarifaires",
    "b2b_credit": "Lignes de crédit",
    "b2b_approvals": "Approbations",
    "b2b_import": "Import en masse",
    "b2b_invoices": "Factures B2B",
    "b2b_aging": "Rapport créances",
    "suppliers": "Fournisseurs",
    "b2b_volume_discounts": "Remises volume",
    "b2b_reps": "Représentants",
    "clients_360": "Clients 360°",
    "segments": "Segmentation",
    "loyalty": "Fidélité",
    "whatsapp": "WhatsApp",
    "sms": "SMS",
    "feedback": "Feedback",
    "abandoned_carts": "Paniers abandonnés",
    "clv": "Valeur client",
    "referrals": "Parrainage",
    "communications": "Communications",
    "promotions": "Promotions",
    "coupons": "Coupons",
    "flash_sales": "Ventes flash",
    "bundles": "Packs / Bundles",
    "banners": "Bannières",
    "newsletter": "Newsletter",
    "seasonal": "Calendrier saisonnier",
    "stacking_rules": "Règles cumul",
    "promo_analytics": "Analytics promos",
    "tracking_links": "Liens sociaux",
    "revenue": "Revenus",
    "tva": "TVA",
    "margins": "Marges",
    "expenses": "Dépenses",
    "invoices": "Factures",
    "cashflow": "Trésorerie",
    "sage_export": "Export Sage",
    "powerbi": "Power BI",
    "reports": "Rapports",
    "daily_pnl": "P&L quotidien",
    "admin_users": "Utilisateurs admin",
    "roles": "Rôles & permissions",
    "audit_log": "Journal d'audit",
    "tasks": "Tâches",
    "shifts": "Planning",
    "agent_performance": "Performance agents",
    "announcements": "Annonces",
    "sla": "SLA",
    "incidents": "Incidents",
    "messages": "Messages",
    "clients": "Clients (CRM)",
    "finances": "Finances",
    "logistics": "Logistique",
    "returns": "Retours",
    "settings": "Paramètres",
    "modules": "Modules",
    "ai_dashboard": "Intelligence IA",
    "analytics_overview": "Vue d'ensemble",
    "demand_forecast": "Prévision demande",
    "smart_pricing": "Tarification intelligente",
    "churn_prediction": "Prédiction attrition",
    "anomaly_detection": "Détection anomalies",
    "replenishment": "Réapprovisionnement",
    "sales_insights": "Analyses ventes",
    "recommendations": "Recommandations",
    "sentiment_analysis": "Analyse sentiments",
    "model_monitor": "Suivi modèles",
    "gdpr": "RGPD / Vie privée",
    "einvoice": "Facturation électronique",
    "backup": "Sauvegardes",
    "api_keys": "Clés API",
    "webhooks": "Webhooks",
    "system_health": "Santé système",
    "feature_flags": "Feature Flags",
    "data_export": "Export données",
    "integrations_page": "Intégrations",
    "operations_hub": "Opérations",
    "error_dashboard": "Erreurs Storefront",
    "account_deletions": "Suppressions comptes",
    "crm": "CRM",
    "marketing_hub": "Marketing",
    "b2b_hub": "B2B",
    "finance_hub": "Finance",
    "analytics_trending": "Tendances",
    "analytics_search": "Recherches",
    "analytics_funnel": "Entonnoir",
    "analytics_intent": "Intentions",
    "content": "Contenu",
    "privacy": "Vie privée",
    "enterprise": "Entreprise",
    "lancement": "Lancement J-Day",
    "yoboulmako_dashboard": "Tableau de bord",
    "yoboulmako_livraisons": "Livraisons en direct",
    "yoboulmako_clients": "Clients",
    "yoboulmako_facturation": "Facturation",
    "yoboulmako_parametres": "Paramètres",
    "djayma_control_tower": "Tour de contrôle",
    "djayma_finance": "Réconciliation",
    "djayma_call_center": "Fiche 360",
    "djayma_stock": "Stock",
    "djayma_orders": "Commandes",
    "djayma_logistique": "Logistique",
    "djayma_pricing": "Grille tarifaire",
    "djayma_promotions": "Promotions",
    "djayma_partners": "Partenaires",
    "djayma_channels": "Canaux",
    "djayma_access": "Accès"
  },
  "header": {
    "title": "Administration Djayma",
    "admin_label": "Administrateur"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "welcome": "Bienvenue dans l'espace d'administration",
    "error": "Impossible de charger les données du tableau de bord. Veuillez réessayer.",
    "kpi": {
      "revenue_today": "Revenus du jour",
      "orders_today": "Commandes du jour",
      "aov": "Panier moyen",
      "pending_payments": "Paiements en attente"
    },
    "charts": {
      "revenue_title": "Évolution du chiffre d'affaires",
      "orders_by_status_title": "Commandes par statut",
      "top_products_title": "Top 5 produits par revenu",
      "region_revenue_title": "Revenus par région",
      "revenue_label": "Revenu",
      "orders_label": "Commandes",
      "no_data": "Aucune donnée pour cette période"
    }
  },
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "search": "Rechercher",
    "filter": "Filtrer",
    "export": "Exporter",
    "create": "Créer",
    "back": "Retour",
    "confirm": "Confirmer",
    "close": "Fermer"
  },
  "status": {
    "active": "Actif",
    "inactive": "Inactif",
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Refusé",
    "processing": "En cours",
    "completed": "Terminé",
    "cancelled": "Annulé"
  },
  "orders": {
    "title": "Commandes",
    "subtitle": "Gérez les commandes de vos clients",
    "col_reference": "Référence",
    "col_client": "Client",
    "col_amount": "Montant TTC",
    "col_status": "Statut",
    "col_payment": "Paiement",
    "col_date": "Date",
    "col_actions": "Actions",
    "filter_status": "Statut",
    "filter_payment": "Paiement",
    "filter_region": "Région",
    "search_placeholder": "Rechercher par réf, client, téléphone...",
    "action_view": "Voir la commande",
    "action_view_short": "Voir",
    "empty": "Aucune commande trouvée.",
    "error_loading": "Impossible de charger les commandes.",
    "error_hint": "Vérifiez votre connexion et réessayez.",
    "retry": "Réessayer",
    "clear_filters": "Effacer les filtres",
    "result_count_one": "{{count}} commande trouvée",
    "result_count_other": "{{count}} commandes trouvées",
    "bulk_confirm": "Confirmer",
    "bulk_cancel": "Annuler",
    "bulk_confirmed_one": "{{count}} commande confirmée",
    "bulk_confirmed_other": "{{count}} commandes confirmées",
    "bulk_cancelled_one": "{{count}} commande annulée",
    "bulk_cancelled_other": "{{count}} commandes annulées",
    "bulk_partial_failure_one": "{{count}} commande n'a pas pu être mise à jour",
    "bulk_partial_failure_other": "{{count}} commandes n'ont pas pu être mises à jour",
    "bulk_error": "Impossible de mettre à jour les commandes.",
    "status": {
      "pending": "En attente",
      "confirmed": "Confirmée",
      "processing": "En préparation",
      "shipped": "Expédiée",
      "delivered": "Livrée",
      "cancelled": "Annulée",
      "cancelled_timeout": "Annulée (délai)",
      "payment_failed": "Paiement échoué"
    },
    "payment_method": {
      "wave": "Wave",
      "orange_money": "Orange Money",
      "carte": "Carte bancaire",
      "especes": "Espèces",
      "virement": "Virement"
    }
  },
  "placeholder": {
    "coming_soon": "Module en cours de développement",
    "coming_soon_description": "Ce module sera bientôt disponible."
  },
  "order_detail": {
    "title": "Commande {{ref}}",
    "back_to_orders": "Retour aux commandes",
    "created_at": "Créée le",
    "customer": "Client",
    "phone": "Téléphone",
    "email": "E-mail",
    "delivery_address": "Adresse de livraison",
    "region": "Région",
    "payment_method": "Mode de paiement",
    "subtotal_ht": "Sous-total HT",
    "tax": "TVA",
    "delivery_fee": "Livraison",
    "total_ttc": "Total TTC",
    "items": "Articles",
    "col_product": "Produit",
    "col_sku": "SKU",
    "col_qty": "Qté",
    "col_unit_price": "Prix unitaire",
    "col_line_total": "Total ligne",
    "timeline": "Historique",
    "notes": "Notes",
    "add_note": "Ajouter une note",
    "note_placeholder": "Saisissez votre note...",
    "note_submit": "Envoyer",
    "note_empty": "Aucune note pour cette commande.",
    "actions_title": "Actions",
    "no_actions_available": "Aucune action disponible pour cette commande.",
    "confirm_order": "Confirmer",
    "cancel_order": "Annuler",
    "process_order": "Mettre en préparation",
    "ship_order": "Expédier",
    "deliver_order": "Marquer livré",
    "retry_payment": "Relancer le paiement",
    "print_delivery_slip": "Imprimer bon de livraison",
    "initiate_refund": "Initier remboursement",
    "confirm_status_title": "Confirmer le changement de statut",
    "confirm_status_message": "Voulez-vous passer la commande au statut \"{{status}}\" ?",
    "confirm_status_yes": "Confirmer",
    "confirm_status_no": "Annuler",
    "error_loading": "Impossible de charger la commande.",
    "error_status_update": "Impossible de mettre à jour le statut.",
    "error_add_note": "Impossible d'ajouter la note.",
    "success_status_update": "Statut mis à jour avec succès.",
    "success_note_added": "Note ajoutée.",
    "not_found": "Commande introuvable",
    "not_found_description": "La commande demandée n'existe pas ou a été supprimée.",
    "no_items": "Aucun article",
    "delivery": "Livraison",
    "driver": "Chauffeur",
    "delivery_status": "Statut livraison",
    "payments": "Paiements",
    "payment_ref": "Réf.",
    "payment_amount": "Montant",
    "payment_status": "Statut",
    "payment_date": "Date"
  },
  "bulk_orders": {
    "confirm": "Confirmer",
    "ship": "Expédier",
    "deliver": "Marquer livré",
    "cancel": "Annuler",
    "confirm_title": "Confirmation",
    "confirm_dialog": "Êtes-vous sûr de vouloir {{action}} {{count}} commandes ?",
    "processing": "En cours…",
    "success": "{{count}} commande(s) mise(s) à jour",
    "all_failed": "Aucune commande mise à jour. Vérifiez les statuts.",
    "partial_success": "{{updated}} commande(s) mise(s) à jour. {{failed}} échec(s).",
    "error": "Erreur : {{message}}",
    "undo": "Annuler",
    "undone": "Mise à jour annulée",
    "undo_failed": "Impossible d'annuler la mise à jour"
  },
  "returns": {
    "col_order": "Commande",
    "col_date": "Date",
    "col_reason": "Motif",
    "col_status": "Statut",
    "col_refund": "Remboursement",
    "col_actions": "Actions",
    "filter_all": "Tous les statuts",
    "empty": "Aucune demande de retour",
    "error_loading": "Impossible de charger les retours.",
    "error_generic": "Une erreur est survenue. Veuillez réessayer.",
    "action_review": "Traiter",
    "action_view": "Voir",
    "modal_title": "Traitement du retour",
    "action_approve": "Approuver",
    "action_reject": "Refuser",
    "refund_amount_label": "Montant du remboursement (FCFA)",
    "refund_method_label": "Mode de remboursement",
    "admin_notes_label": "Note interne (optionnel)",
    "admin_notes_placeholder": "Commentaire visible par l'équipe uniquement…",
    "pagination_info": "Page {{page}} / {{total_pages}} — {{total}} demande(s)",
    "prev_page": "Page précédente",
    "next_page": "Page suivante"
  },
  "stock_alerts": {
    "title": "Règles d'alerte stock",
    "add_rule": "Ajouter une règle",
    "create_rule_title": "Nouvelle règle d'alerte",
    "edit_rule_title": "Modifier la règle d'alerte",
    "col_scope": "Produit / Catégorie",
    "col_threshold": "Seuil",
    "col_channels": "Canaux",
    "col_auto_reorder": "Réappro. auto",
    "col_status": "Statut",
    "col_actions": "Actions",
    "auto_reorder_on": "Auto",
    "field_scope": "Portée",
    "scope_product": "Produit",
    "scope_category": "Catégorie",
    "field_product": "Produit",
    "product_placeholder": "ID du produit",
    "field_category": "Catégorie",
    "category_placeholder": "ID de la catégorie",
    "field_threshold": "Seuil minimum de stock",
    "field_channels": "Canaux de notification",
    "field_auto_reorder": "Réapprovisionnement automatique",
    "auto_reorder_tooltip": "Créer automatiquement un bon de commande",
    "field_active": "Règle active",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer cette règle d'alerte ?",
    "error_loading": "Impossible de charger les règles d'alerte.",
    "empty_title": "Aucune règle d'alerte",
    "empty_description": "Créez votre première règle pour être alerté lorsque le stock est bas."
  },
  "categories": {
    "page_title": "Catégories",
    "page_description": "Organisez vos produits en catégories et sous-catégories (3 niveaux max).",
    "add": "Nouvelle catégorie",
    "create_title": "Créer une catégorie",
    "edit_title": "Modifier la catégorie",
    "empty": "Aucune catégorie",
    "empty_hint": "Créez votre première catégorie pour organiser vos produits.",
    "error_loading": "Impossible de charger les catégories.",
    "expand": "Développer",
    "collapse": "Réduire",
    "add_child": "Ajouter une sous-catégorie",
    "product_count_one": "{{count}} produit",
    "product_count_other": "{{count}} produits",
    "product_count": "{{count}} produit(s)",
    "field_name_fr": "Nom (français)",
    "field_name_wo": "Nom (wolof)",
    "field_name_en": "Nom (anglais)",
    "field_slug": "Slug",
    "field_parent": "Catégorie parente",
    "field_image": "Image (URL)",
    "field_active": "Catégorie active",
    "placeholder_name_fr": "Ex : Produits laitiers",
    "placeholder_name_wo": "Ex : Meew",
    "placeholder_name_en": "Ex : Dairy products",
    "no_parent": "— Aucune (racine) —",
    "select_parent": "Choisir une catégorie...",
    "delete_title": "Supprimer la catégorie",
    "delete_confirm": "Voulez-vous vraiment supprimer « {{name}} » ?",
    "delete_has_products": "Cette catégorie contient {{count}} produit(s). Ils seront détachés.",
    "delete_has_children": "Cette catégorie a {{count}} sous-catégorie(s). Que souhaitez-vous faire ?",
    "move_children_to": "Déplacer les sous-catégories vers...",
    "delete_all_children": "Supprimer tout (catégorie + sous-catégories)",
    "deleting": "Suppression..."
  },
  "images": {
    "image": "Image",
    "primary": "Principale",
    "is_primary": "Image principale",
    "set_primary": "Définir comme principale",
    "delete": "Supprimer",
    "confirm_delete": "Confirmer la suppression",
    "deleted": "Image supprimée",
    "add": "Ajouter",
    "upload_success": "Image envoyée avec succès",
    "max_reached": "Maximum {{max}} images par produit",
    "count": "{{current}} / {{max}} images",
    "empty_title": "Aucune image",
    "empty_description": "Cliquez pour ajouter des images au produit",
    "select_files": "Sélectionner des fichiers",
    "invalid_type": "Type de fichier non supporté. Formats acceptés : JPEG, PNG, WebP, AVIF.",
    "file_too_large": "Le fichier dépasse la taille maximale de {{max}} Mo",
    "upload_error": "Erreur lors de l'envoi de l'image",
    "reorder_error": "Erreur lors de la réorganisation des images"
  },
  "products": {
    "stock": {
      "drawer_title": "Ajustement du stock",
      "current_stock": "Stock actuel",
      "threshold": "Seuil d'alerte",
      "threshold_default": "Seuil : {{value}} (défaut)",
      "threshold_custom": "Seuil : {{value}} (personnalisé)",
      "direction_reception": "Réception (+)",
      "direction_sortie": "Sortie (-)",
      "direction_correction": "Correction (+/-)",
      "quantity": "Quantité",
      "reason": "Motif",
      "reason_restock": "Réapprovisionnement",
      "reason_sale": "Vente",
      "reason_return": "Retour",
      "reason_adjustment": "Ajustement",
      "notes": "Notes",
      "notes_required": "Notes obligatoires pour les ajustements",
      "preview": "{{from}} → {{to}} ({{delta}})",
      "confirm": "Confirmer l'ajustement",
      "success": "Stock mis à jour avec succès",
      "error_insufficient": "Stock insuffisant pour cette opération",
      "history_title": "Historique des mouvements",
      "history_empty": "Aucun mouvement enregistré",
      "history_full_link": "Voir l'historique complet",
      "history_filter_reason": "Filtrer par motif",
      "history_filter_date": "Filtrer par date"
    },
    "conflict": {
      "title": "Conflit de version",
      "message": "Le stock a été modifié par {{actor}} il y a {{time}}.",
      "your_stock": "Stock quand vous avez ouvert",
      "current_stock": "Stock actuel",
      "your_change": "Votre changement",
      "option_apply": "Appliquer mon {{delta}} au nouveau stock → {{result}}",
      "option_keep": "Garder le nouveau stock ({{current}}, abandonner mon changement)",
      "option_cancel": "Annuler",
      "apply_choice": "Appliquer mon choix"
    },
    "bulk": {
      "selected": "{{count}} produit(s) sélectionné(s)",
      "deselect": "Désélectionner",
      "select_all_page": "Tous les {{count}} produits de cette page sont sélectionnés.",
      "select_all_filtered": "Sélectionner les {{count}} produits filtrés",
      "activate": "Activer",
      "deactivate": "Désactiver",
      "price": "Prix",
      "category": "Catégorie",
      "threshold": "Seuil bas",
      "export_csv": "Exporter CSV",
      "delete": "Supprimer",
      "confirm_activate": "Activer {{count}} produit(s)",
      "confirm_deactivate": "Désactiver {{count}} produit(s)",
      "confirm_delete": "Supprimer {{count}} produit(s)",
      "typed_confirm_prompt": "Pour confirmer, tapez le nombre exact :",
      "typed_confirm_warning": "Cette action peut être annulée sous 5 secondes.",
      "price_mode_absolute": "Prix absolu",
      "price_mode_percent": "Pourcentage",
      "price_preview_old": "Ancien prix",
      "price_preview_new": "Nouveau prix",
      "price_reason": "Motif du changement de prix",
      "category_select": "Nouvelle catégorie",
      "threshold_input": "Nouveau seuil",
      "threshold_reset": "Réinitialiser au défaut",
      "pending_approval": "En attente d'approbation par la Direction",
      "undo_toast": "Annuler ({{seconds}}s)",
      "undo_success": "Action annulée"
    },
    "command_palette": {
      "placeholder": "Rechercher un produit ou une action...",
      "adjust_stock": "Ajuster le stock de...",
      "mark_out": "Marquer en rupture...",
      "export_view": "Exporter la vue actuelle",
      "new_product": "Nouveau produit",
      "import_csv": "Importer CSV",
      "stock_alerts": "Aperçu des alertes stock",
      "pending_approvals": "Voir les approbations en attente",
      "no_results": "Aucun résultat"
    },
    "keyboard": {
      "cheatsheet_title": "Raccourcis clavier",
      "nav_up": "Ligne précédente",
      "nav_down": "Ligne suivante",
      "toggle_select": "Sélectionner / désélectionner",
      "select_all": "Tout sélectionner (page)",
      "clear": "Annuler sélection / fermer",
      "edit": "Modifier le produit",
      "stock_drawer": "Ouvrir le tiroir stock",
      "command_palette": "Palette de commandes",
      "focus_search": "Focus sur la recherche",
      "show_shortcuts": "Afficher les raccourcis"
    },
    "alerts": {
      "title": "Alertes stock",
      "out_of_stock": "en rupture",
      "low_stock": "stock bas",
      "view_all": "Voir tous les produits en alerte"
    },
    "approvals": {
      "title": "Approbations en attente",
      "empty": "Aucune approbation en attente",
      "approve": "Approuver",
      "reject": "Rejeter",
      "reject_reason": "Motif du rejet",
      "approved_success": "Action approuvée et exécutée",
      "rejected_success": "Action rejetée",
      "expires_in": "Expire dans {{time}}",
      "expired": "Expirée",
      "maker": "Demandeur",
      "action": "Action",
      "affected": "Produits concernés"
    },
    "table": {
      "presence_editing": "{{name}} est en train de modifier ce produit",
      "realtime_updated": "Mis à jour par {{name}}",
      "sort_asc": "Trier par ordre croissant",
      "sort_desc": "Trier par ordre décroissant"
    },
    "error_boundary": {
      "title": "Erreur inattendue",
      "message": "Un problème est survenu lors du chargement des produits.",
      "retry": "Réessayer",
      "report": "Signaler le problème"
    }
  }
}
